import React, {useEffect} from "react";
import Image from "next/image";
import bookImage from "../../../public/assets/images/book-a-visit-img.jpg";
import bookingStyle from "../../styles/sass/book-a-visit.module.scss";
import Tourform from "../utils/Tourform";
import BannerInner from "../common-components/bannerinner/BannerInner";
import bannerImage from "../../../public/assets/images/banner-img-top-5.jpg";

const BookaVisit = ({ tourForm, tourFormToggle }) => {
    
    

    return (
        <>  
            <BannerInner title={"Book a Visit"} imageSrc={ bannerImage} />
            <section className={`mc_container_fluid p-spacerT p-spacerB ${bookingStyle["booking-form-cb"]}`}>
                <div className="mc_row_new">
                    <div className="mc_container_inner">
                        <div className="mc_row_new">
                            <div className={`${bookingStyle["col_full"]}`}>
                                <div className="">
                                    <div className="c-text-container mob-text-center">
                                        <div>
                                        <p>Discover Bermondsey: Book Your Visit Today!</p>
                                        </div>
                                    </div>
                                    <Tourform tourForm={tourForm} tourFormToggle={tourFormToggle} pageName={"Book a Visit"}/>
                                </div>
                            </div>

                            <div className={`${bookingStyle["con_auto"]}`}>
                                <div className="">
                                    <Image 
                                        src={bookImage.src}
                                        width={500}
                                        height={600} 
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

                {/* <div className="bw_container mob_a_u_cb" style={{ backgroundImage: `url(${cookieImg.src})` }}>
                    <div
                        className="bw_l_c"
                        style={{ backgroundImage: `url(${cookieImg.src})` }}
                    ></div>
                    <div className="bw_r_c">
                        <div className="bw_s_w_cb">
                            <div className="outer_bw_cb">
                                <div className="bw_cb">
                                    <Tourform tourForm={tourForm} tourFormToggle={tourFormToggle} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
            
        </>
    );
};

export default BookaVisit;